// extracted by mini-css-extract-plugin
module.exports = {"files":"FileUpload_files__3gDc-","head":"FileUpload_head__38uKk"};